import Cookies from "js-cookie";
import { SECURE_COOKIE_OPTIONS } from "@/utils/cookies/cookieOptions";

// After a failed payment the checkout SSR asks MW to renew the cart of the order,
// and Magento only renews it when the cart id is the quote that became the order.
// Most payment components replace the `quote` cookie with a new empty cart before
// leaving for the gateway, so the consumed quote id is kept here from place-order
// until the gateway redirects back. Like `quote`, it is a cart id, not a secret.
export const ORDER_QUOTE_COOKIE = "order_quote";
export const ORDER_QUOTE_MAX_AGE_S = 60 * 60;

// The quote cookie can hold the literal "undefined" / "null" (a JS cookie set from
// an empty value).
export const normalizeQuoteId = (value) => {
  if (typeof value !== "string") return null;
  const id = value.trim();
  if (!id || id === "undefined" || id === "null") return null;
  return id;
};

// Browser writer, called right after a successful place-order.
export const writeOrderQuoteCookie = (quote) => {
  const value = normalizeQuoteId(quote);
  if (!value) return;
  Cookies.set(ORDER_QUOTE_COOKIE, value, {
    path: "/",
    expires: new Date(Date.now() + ORDER_QUOTE_MAX_AGE_S * 1000),
    ...SECURE_COOKIE_OPTIONS,
  });
};
